export default "/assets/images/unit-slide2.webp?df88c47d767f4ed4ef91938fb63139f2";